import { Plus, SlidersHorizontal, UtensilsCrossed } from "lucide-react";
import { formatARS } from "@/lib/api";

export const ProductCard = ({ product, isPizza, onSelect, index = 0 }) => {
  const out = !product.available;
  return (
    <button
      type="button"
      disabled={out}
      onClick={() => onSelect(product)}
      data-testid={`product-card-${product.id}`}
      style={{ animationDelay: `${index * 50}ms` }}
      className={`rise group w-full text-left flex gap-3 p-3 rounded-2xl bg-[#FFFDF9] border border-[#EFE6D8] shadow-md transition-[transform,box-shadow] duration-200 ${
        out ? "opacity-60 grayscale cursor-not-allowed" : "hover:-translate-y-0.5 hover:shadow-xl active:scale-[0.99]"
      }`}
    >
      <div className="relative w-28 h-28 shrink-0 rounded-xl overflow-hidden bg-[#F7F2EA] flex items-center justify-center">
        {product.image ? (
          <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <UtensilsCrossed className="w-10 h-10 text-[#C9B9A3]" />
        )}
        {out && (
          <span className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xs font-bold tracking-widest" data-testid={`product-soldout-${product.id}`}>
            AGOTADO
          </span>
        )}
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <h3 className="font-bold text-[#1F1917] text-base leading-tight" data-testid={`product-name-${product.id}`}>{product.name}</h3>
        <p className="text-xs text-[#645A53] mt-1 line-clamp-2">{product.description}</p>
        <div className="mt-auto flex items-end justify-between pt-2">
          <span className="font-price text-2xl text-[#B91C1C]" data-testid={`product-price-${product.id}`}>{formatARS(product.price)}</span>
          {!out && (
            <span className="inline-flex items-center gap-1 rounded-full bg-[#DC2626] text-white text-xs font-semibold px-3 py-1.5 group-hover:bg-[#991B1B] transition-colors">
              {isPizza ? <SlidersHorizontal className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
              {isPizza ? "Personalizar" : "Agregar"}
            </span>
          )}
        </div>
      </div>
    </button>
  );
};
